import React, { useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useLanguage } from '../../../contexts/LanguageContext';

export default function DealerStockVehiclesTable({
    items,
    totalCount,
    loading,
    lazyParams,
    onPage,
    sortField,
    sortOrder,
    onSortChange
}) {
    const { th } = useLanguage();
    const dataTableRef = useRef(null);

    const rows = Array.isArray(items)
        ? items.map((item, index) => ({ ...item, _rowId: `${lazyParams.first}-${index}` }))
        : [];

    const formatDate = (rowData) => {
        if (!rowData.createdDate) return '';
        try {
            const date = new Date(rowData.createdDate);
            return date.toLocaleDateString('tr-TR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        } catch {
            return rowData.createdDate;
        }
    };

    return (
        <DataTable
            value={rows}
            dataKey="_rowId"
            lazy
            paginator
            rows={lazyParams.rows}
            first={lazyParams.first}
            totalRecords={totalCount}
            onPage={onPage}
            loading={loading}
            emptyMessage={th('common.noRecords')}
            rowsPerPageOptions={[10, 25, 50]}
            showGridlines
            tableStyle={{ minWidth: '80rem' }}
            sortField={sortField}
            sortOrder={sortOrder}
            onSort={onSortChange}
            ref={dataTableRef}
        >
            <Column sortable field="brand" header={th('karsanStockVehiclesReport.columns.brand')} style={{ minWidth: '130px' }} />
            <Column sortable field="model" header={th('karsanStockVehiclesReport.columns.model')} style={{ minWidth: '130px' }} />
            <Column sortable field="maktx" header={th('karsanStockVehiclesReport.columns.maktx')} style={{ minWidth: '180px' }} />
            <Column sortable field="matnr" header={th('karsanStockVehiclesReport.columns.matnr')} style={{ minWidth: '180px' }} />
            <Column sortable field="chassisNo" header={th('karsanStockVehiclesReport.columns.chassisNo')} style={{ minWidth: '200px' }} />
            <Column sortable field="dealerCode" header={th('karsanStockVehiclesReport.columns.dealerCode')} style={{ minWidth: '120px' }} />
            <Column sortable field="dealerName" header={th('karsanStockVehiclesReport.columns.dealerName')} style={{ minWidth: '180px' }} />
            <Column sortable field="statusText" header={th('karsanStockVehiclesReport.columns.statusText')} style={{ minWidth: '120px' }} />
            <Column sortable field="createdDate" header={th('karsanStockVehiclesReport.columns.createdDate')} style={{ minWidth: '180px' }} body={formatDate} />
        </DataTable>
    );
}
